 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		38: 0,
 		0: 0,
 		1: 0,
 		2: 0,
 		3: 0,
 		4: 0,
 		10: 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"4":"vendors~BulkRoster~ContentAccessLookup~MergeApproval~MergeRequest~OneRosterOrgs~ProvisionSchools~Pygmalion","6":"MergeApproval~MergeRequest~UserDash","7":"News","8":"Bulk-Processing-Status","9":"MergeApproval~MergeRequest","11":"AssignmentContainer","12":"AssignmentsContainer","13":"BulkRoster","14":"ContentAccessLookup","15":"District-Report","16":"Home","17":"LazyAssignedArticleReviewContainer","18":"LazyCanvasAssignmentReviewContainer","19":"LazySearchComponent","20":"LessonSparkContainer","21":"MergeApproval","22":"MergeRequest","23":"OneRosterOrgs","24":"OpenMergeRequests","25":"ProvisionSchools","26":"Pygmalion","27":"ReadContainer","28":"StandaloneExternalEmbed","29":"StandalonePoll","30":"StandardContainer","31":"TeacherBinder","32":"TextSets","33":"UnitsContainer","34":"UserDash","35":"YourContentContainer","37":"browse","40":"vendors~ProvisionSchools","41":"vendors~browse"}[chunkId]||chunkId) + "." + {"0":"50f073d960b1eaa5ee44","1":"8368965eb47f8105cfa0","2":"a2ac7fb62790d050dc72","3":"45146c3d44f8994dcb53","4":"8e7d6fccc5fe6277734d","5":"438cd52c8d40c1d8a5e9","6":"3a9892e5ec544b9485ea","7":"101846236b59edd5f8bb","8":"53988caaee41d3c5fe67","9":"5b3add959d262f02046c","10":"76a35c361f62cce64fef","11":"e20c78b85b185e5d641f","12":"0234f94a3db6e3ef73aa","13":"4652a5466591d19a0333","14":"7fdcc6735ce9a1cfd57b","15":"3ea89e466a4f323a5914","16":"020a5d07659adad47985","17":"927dd50bd9a20ed2aab7","18":"88bcbbe3842fad14885d","19":"c6eea56b58eaa35007ab","20":"10f42f9ca531f1064d1c","21":"6cee48796993af53d06e","22":"acb538d7c9620af5fae0","23":"9341801f8f49415e4518","24":"82b657ede3dc0483e259","25":"35721db9f08f07de7361","26":"888b4e57360f154e0f63","27":"d0ef7cbfef3ae8946efa","28":"207ad12202bb55ad75ea","29":"471f625372e27a255f0e","30":"3ec74bf1208911345071","31":"80a1eea9b7c5abb0152a","32":"e6438600741ec9113f14","33":"c44afa0171dd82cd511b","34":"c44139d82c4e191bb56f","35":"45e92bf7db879ae79c2c","37":"6d7ed2d1fa9cacaea496","40":"88233bb0c81f7357303c","41":"b1d3ce2565ba60d284e6","42":"19b3acd897a9287217ab","43":"dba6c37f4cda416cc537","44":"c66d5b76f74b43063a57","45":"6d3ad3a23c903f0472d6","46":"ac0a9341c82acc72dda7","47":"c095ddd295295f468a6c","48":"7b7d292bc63ac07344e5","49":"83f18ac79a49991ae927","50":"7211ef404cbbf41d14df","51":"0e11b8ed4bd720664e2e","52":"997794c22026783ad495"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 1609);
